/**
 * ISMOOLI Product View Tracker
 * Records PDP views for recently viewed discovery.
 */
(function () {
  const dataElement = document.getElementById('glyc-product-track-data');
  if (!dataElement || !window.GlycRecentlyViewed) return;

  try {
    const product = JSON.parse(dataElement.textContent);
    GlycRecentlyViewed.track(product);
  } catch {
    /* invalid product payload */
  }
})();
